function computeAgencyCommissionWithMultiplier(
  invoiceValue,
  conversionRate,
  multiplier,
) {
  const v = parseFloat(invoiceValue);
  const cr = parseFloat(conversionRate);
  if (Number.isNaN(v) || Number.isNaN(cr)) {
    return 1000;
  }
  const raw = v * cr * multiplier;
  return Math.max(1000, Math.round(raw * 100) / 100);
}

/** Import C&F Bill: invoice_value × conversion_rate × 0.001 Taka, minimum 1000. */
export function computeImportAgencyCommissionTaka(invoiceValue, conversionRate) {
  return computeAgencyCommissionWithMultiplier(
    invoiceValue,
    conversionRate,
    0.001,
  );
}

/** Export C&F Bill: invoice_value × conversion_rate × 0.1 Taka, minimum 1000. */
export function computeExportAgencyCommissionTaka(invoiceValue, conversionRate) {
  return computeAgencyCommissionWithMultiplier(
    invoiceValue,
    conversionRate,
    0.1,
  );
}
